export default function IndexCard({
    type = null,
    buttons,
    status = '',
    title = '',
    subtitle = '',
    infos = [],
    image = null,
    header = null,
    onClick = () => {}
}) {
    return (
        <div className={`card`}>
            { header && header }
            
            { image !== null && typeof image == 'string' && <div className="card__image" style={{ backgroundImage: `url(${image})` }}></div> }

            <div className="card__outer">
                <div className="card__content">
                    <div>
                        <p className="card__title">{title}</p>
                        { subtitle && subtitle.length > 0 ? <p className="card__provider" dangerouslySetInnerHTML={{ __html: subtitle }}></p> : <p className="card__provider" style={{ fontSize: '15.5px' }}>ㅤ</p> }

                        <div className="card__information">
                            {
                                infos.map((i, index) => {
                                    return (
                                        <div key={index} className="card-information__item">
                                            <p className="card-information-item__title">{i.label}</p>
                                            <p className="card-information-item__date">{i.value}</p>
                                        </div>

                                    );
                                })
                            }
                        </div>
                    </div>

                    <div className="card__buttons">
                        { buttons ? buttons : ''}
                    </div>
                </div>
            </div>
        </div>
    )
}
